Array.prototype.average = function () {
  return this.reduce((p, c) => p + c, 0) / this.length
}
